var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ContentConfirm"
  }, [_c('h2', {
    staticClass: "ContentConfirm-text",
    class: 'ContentConfirm-text--' + _vm.type,
    attrs: {
      "aria-label": _vm.text,
      "tabindex": "0"
    }
  }, [_vm.icon ? _c('span', {
    staticClass: "ContentConfirm-icon",
    class: _vm.icon
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.text) + " ")]), _c('div', {
    staticClass: "ContentConfirm-buttons"
  }, [_c('rounded-button', {
    staticClass: "ContentConfirm-button",
    attrs: {
      "label": _vm.$t('button.cancel'),
      "type": 'cancel'
    },
    on: {
      "buttonClicked": _vm.cancel
    }
  }), _c('rounded-button', {
    staticClass: "ContentConfirm-button",
    attrs: {
      "label": _vm.$t('button.validate'),
      "type": 'reversed'
    },
    on: {
      "buttonClicked": _vm.validate
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }